import { combineReducers } from 'redux';
import app from './app.js';
import auth from './auth/auth';
import mail from './mail.js';
import calendar from './calendar.js';
import folders from './folders/folders';
import files from './files/files';
import time from './time';
import salesforceRecords from './salesforceRecords';

const appReducer = combineReducers({
  app,
  auth,
  mail,
  calendar,
  folders,
  files,
  time,
  salesforceRecords,
});

const rootReducer = (state, action) => {
  if (action.type === 'CHANGE_EMAIL') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
